import { useState, useEffect } from 'react'
import { Plus, AlertCircle, CheckCircle } from 'lucide-react'
import BrechaCard from './BrechaCard'
import BrechaForm from './BrechaForm'
import { useBrechasStore } from '../../store/brechasStore'
import { useAuthStore } from '../../store/authStore'

const BrechasList = ({ criterioId, readOnly = false }) => {
  const { brechas, fetchBrechasByCriterio, isLoading, error } = useBrechasStore()
  const { token, user } = useAuthStore()
  const [showForm, setShowForm] = useState(false)
  
  // Determinar si el usuario puede editar (no es admin)
  const canEdit = !readOnly && user?.role !== 'admin'

  useEffect(() => {
    if (criterioId && token) {
      fetchBrechasByCriterio(criterioId, token)
    }
  }, [criterioId, token])

  const handleBrechaClick = (brecha) => {
    // TODO: Navigate to brecha detail page
    console.log('Brecha clicked:', brecha)
  }

  const handleSuccess = () => {
    // Refresh list after creating new brecha
    fetchBrechasByCriterio(criterioId, token)
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded flex items-center space-x-2">
        <AlertCircle className="h-5 w-5" />
        <span>{error}</span>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {/* Header with Add Button */}
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900">
          Brechas Registradas ({brechas.length})
        </h3>
        {canEdit && (
          <button
            onClick={() => setShowForm(true)}
            className="btn-primary inline-flex items-center space-x-2"
          >
            <Plus className="h-4 w-4" />
            <span>Registrar Brecha</span>
          </button>
        )}
      </div>

      {/* Empty State */}
      {brechas.length === 0 ? (
        <div className="text-center py-12 bg-green-50 rounded-lg border-2 border-dashed border-green-200">
          <CheckCircle className="h-12 w-12 text-green-500 mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            ¡Excelente! No hay brechas registradas
          </h3>
          <p className="text-gray-600 mb-4">
            Este criterio no tiene debilidades o áreas de mejora identificadas.
          </p>
          <p className="text-sm text-gray-500">
            Si detectas alguna área de mejora, puedes registrarla haciendo clic en el botón de arriba.
          </p>
        </div>
      ) : (
        /* Brechas List */
        <div className="grid gap-4">
          {brechas.map(brecha => (
            <BrechaCard
              key={brecha.id}
              brecha={brecha}
              onClick={() => handleBrechaClick(brecha)}
            />
          ))}
        </div>
      )}

      {/* Form Modal - Solo para usuarios que pueden editar */}
      {canEdit && showForm && (
        <BrechaForm
          criterioId={criterioId}
          onClose={() => setShowForm(false)}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  )
}

export default BrechasList
